import { render, staticRenderFns } from "./GammaAuthenticator.vue?vue&type=template&id=6b91e27d&scoped=true"
import script from "./GammaAuthenticator.vue?vue&type=script&lang=ts"
export * from "./GammaAuthenticator.vue?vue&type=script&lang=ts"
import style0 from "./GammaAuthenticator.vue?vue&type=style&index=0&id=6b91e27d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b91e27d",
  null
  
)

export default component.exports